import React, { useState } from 'react';
import { Button, ToastMessage } from '@cokitchen/cokitchen-components';
import { AddIcon } from 'cokitchen-icons';
import InsufficientTag from 'components/base/insufficient-tag';
import useDashboardContext from 'contexts/dashboard.context';
import { toast } from 'react-toastify';
import { apiService } from 'services/base.service';
import { formatCurrency } from 'utils/functions';
import useGiftMembersContext from 'contexts/gift-members.context';
import FundWalletModal from 'components/modals/fund-wallet-modal';
import { useNavigate } from 'react-router-dom';
import { ROUTE_KEYS } from 'utils/constants';

const GiftMembersConfirm = () => {
  const navigate = useNavigate();
  const { activeCompany, monthlyStat, refetchMonthlyStat } = useDashboardContext();
  const { beneficiaries } = useGiftMembersContext();
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState(false);
  const totalAmount = beneficiaries.reduce(
    (amount, beneficiary) => amount + +beneficiary.amount,
    0
  );

  const giftMembers = async () => {
    if (!activeCompany.id) return;
    setLoading(true);
    try {
      const gift_data = beneficiaries.map((b) => ({ user_id: b.user_id, amount: b.amount }));
      await apiService.post('gift/bulk', { data: { company_id: activeCompany.id, gift_data } });
      toast(<ToastMessage type='success' message='Members gifted successfully' />);
      setLoading(false);
      refetchMonthlyStat();
      navigate(ROUTE_KEYS.DASHBOARD);
    } catch (err) {
      setLoading(false);
    }
  };

  return (
    <div className='w-full max-w-[390px] mx-auto'>
      <div className='flex flex-col'>
        <h4 className='text-[32px] text-[#2E3031] font-semibold mb-1'>Gift member(s)</h4>
        <p className='text-[#6F7376] mb-8'>Appreciate your employees by gifting them</p>
        <div className='bg-[#F7F7F7] rounded-md border border-[#F0EFEF] w-full h-[128px] flex flex-col justify-center items-center mb-10'>
          <p className='text-[#6F7376] mb-1 text-sm'>Total amount is</p>
          <p className='text-[32px] font-semibold'>{formatCurrency(totalAmount)}</p>
        </div>
        <div className='w-full py-3 px-4 rounded-md border border-[#E60A2B] flex justify-between items-center mb-2'>
          <div>
            <p className='text-sm text-[#2E3031] font-medium'>Food Court Wallet</p>
            <p className='text-[#6F7376] text-xs'>
              Balance: {formatCurrency(monthlyStat.business_balance)}
            </p>
          </div>
          <div>
            <InsufficientTag insufficient={totalAmount > +monthlyStat.business_balance} />
          </div>
        </div>
        {totalAmount > +monthlyStat.business_balance ? (
          <div
            className='cursor-pointer flex items-center gap-[2px] text-[#0080E5]'
            onClick={() => setModal(true)}>
            <p className=' text-xs font-medium'>Fund wallet</p>
            <AddIcon className='w-4 h-4' />
          </div>
        ) : null}
        <Button
          disabled={totalAmount > +monthlyStat.business_balance}
          loading={loading}
          onClick={giftMembers}
          variant='block'
          color='primary'
          className='mt-12 h-[53px]'>
          Proceed
        </Button>
      </div>
      {modal ? <FundWalletModal isOpen={modal} onClose={() => setModal(false)} /> : null}
    </div>
  );
};

export default GiftMembersConfirm;
